import { collection, query, where, getDocs, doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * @deprecated LEGACY — do not confuse with `src/helpers/practiceDataUtil.js`, which is the
 * real practice data module (practices.json-backed getAllPractices/getPracticeByCode used
 * everywhere else). This file only checks an old per-user `practices` Firestore subcollection
 * and has no JSON lookup capability. Only `App.js` still calls it (initializeForUser); safe to
 * remove once that call is confirmed unnecessary.
 */
class PracticeDataUtil {
  constructor() {
    this.initialized = new Map();
  }

  /**
   * Initialize practice data for a user
   * @param {string} userId - The user ID
   */
  async initializeForUser(userId) {
    if (!userId) {
      console.error('Cannot initialize practices for undefined userId');
      return false;
    }

    if (this.initialized.get(userId)) {
      console.log(`[PRACTICE-DEBUG] Practices already initialized for ${userId}`);
      return true;
    }

    console.log(`Initializing practice data for user: ${userId}`);

    try {
      // First check if user already has practices
      const practicesRef = collection(db, 'practices');
      const q = query(practicesRef, where('userId', '==', userId));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        console.log(`User ${userId} already has ${querySnapshot.size} practices. No initialization needed.`);
        this.initialized.set(userId, true);
        return true;
      }

      // Get user document to check for migration data
      const userDoc = await getDoc(doc(db, 'users', userId));
      if (!userDoc.exists()) {
        console.warn(`User document for ${userId} not found for practice initialization`);
        this.initialized.set(userId, true); // Mark as initialized anyway
        return false;
      }

      // Check for updates periodically
      this.checkForUpdates();

      this.initialized.set(userId, true);
      return true;
    } catch (error) {
      console.error('Error initializing practice data:', error);
      return false;
    }
  }

  /**
   * Check for practice data updates
   */
  checkForUpdates() {
    console.log('[PRACTICE-DEBUG] checkForUpdates called');
    // Placeholder for potential update checking functionality
  }
}

// Export a singleton instance
export const practiceDataUtil = new PracticeDataUtil();
